import routeParams from 'helpers/routeParams'

const GET_ADVENTUROUS_JOURNEYS = 'dofe-bo/advjouEvents/GET_ADVENTUROUS_JOURNEYS'
const GET_ADVENTUROUS_JOURNEYS_SUCCESS =
  'dofe-bo/advjouEvents/GET_ADVENTUROUS_JOURNEYS_SUCCESS'
const GET_ADVENTUROUS_JOURNEYS_FAIL =
  'dofe-bo/advjouEvents/GET_ADVENTUROUS_JOURNEYS_FAIL'

const GET_ADVENTUROUS_JOURNEY = 'dofe-bo/advjouEvents/GET_ADVENTUROUS_JOURNEY'
const GET_ADVENTUROUS_JOURNEY_SUCCESS =
  'dofe-bo/advjouEvents/GET_ADVENTUROUS_JOURNEY_SUCCESS'
const GET_ADVENTUROUS_JOURNEY_FAIL =
  'dofe-bo/advjouEvents/GET_ADVENTUROUS_JOURNEY_FAIL'

const UPDATE_ADVENTUROUS_JOURNEY =
  'dofe-bo/advjouEvents/UPDATE_ADVENTUROUS_JOURNEY'
const UPDATE_ADVENTUROUS_JOURNEY_SUCCESS =
  'dofe-bo/advjouEvents/UPDATE_ADVENTUROUS_JOURNEY_SUCCESS'
const UPDATE_ADVENTUROUS_JOURNEY_FAIL =
  'dofe-bo/advjouEvents/UPDATE_ADVENTUROUS_JOURNEY_FAIL'

const UPLOAD_AJ_FILE = 'dofe-bo/advjouEvents/UPLOAD_AJ_FILE'
const UPLOAD_AJ_FILE_SUCCESS = 'dofe-bo/advjouEvents/UPLOAD_AJ_FILE_SUCCESS'
const UPLOAD_AJ_FILE_FAIL = 'dofe-bo/advjouEvents/UPLOAD_AJ_FILE_FAIL'

const DELETE_ADVENTUROUS_JOURNEY =
  'dofe-bo/advjouEvents/DELETE_ADVENTUROUS_JOURNEY'
const DELETE_ADVENTUROUS_JOURNEY_SUCCESS =
  'dofe-bo/advjouEvents/DELETE_ADVENTUROUS_JOURNEY_SUCCESS'
const DELETE_ADVENTUROUS_JOURNEY_FAIL =
  'dofe-bo/advjouEvents/DELETE_ADVENTUROUS_JOURNEY_FAIL'

const EXPORT_AJ_EVENTS = 'dofe-bo/advjouEvents/EXPORT_AJ_EVENTS'
const EXPORT_AJ_EVENTS_SUCCESS = 'dofe-bo/advjouEvents/EXPORT_AJ_EVENTS_SUCCESS'
const EXPORT_AJ_EVENTS_FAIL = 'dofe-bo/advjouEvents/EXPORT_AJ_EVENTS_FAIL'

const GET_ADVENTUROUS_JOURNEY_FILES =
  'dofe-bo/advjouEvents/GET_ADVENTUROUS_JOURNEY_FILES'
const GET_ADVENTUROUS_JOURNEY_FILES_SUCCESS =
  'dofe-bo/advjouEvents/GET_ADVENTUROUS_JOURNEY_FILES_SUCCESS'
const GET_ADVENTUROUS_JOURNEY_FILES_FAIL =
  'dofe-bo/advjouEvents/GET_ADVENTUROUS_JOURNEY_FILES_FAIL'

const CRUD = 'dofe-bo/advjouEvents/CRUD'
const CRUD_SUCCESS = 'dofe-bo/advjouEvents/CRUD_SUCCESS'
const CRUD_FAIL = 'dofe-bo/advjouEvents/CRUD_FAIL'

const EDIT_AJ_FILE = 'dofe-bo/advjouEvents/EDIT_AJ_FILE'
const EDIT_AJ_FILE_SUCCESS = 'dofe-bo/advjouEvents/EDIT_AJ_FILE_SUCCESS'
const EDIT_AJ_FILE_FAIL = 'dofe-bo/advjouEvents/EDIT_AJ_FILE_FAIL'

const REMOVE_AJ_FILE = 'dofe-bo/advjouEvents/REMOVE_AJ_FILE'
const REMOVE_AJ_FILE_SUCCESS = 'dofe-bo/advjouEvents/REMOVE_AJ_FILE_SUCCESS'
const REMOVE_AJ_FILE_FAIL = 'dofe-bo/advjouEvents/REMOVE_AJ_FILE_FAIL'

const CREATE_ADVENTUROUS_JOURNEY =
  'dofe-bo/advjouEvents/CREATE_ADVENTUROUS_JOURNEY'
const CREATE_ADVENTUROUS_JOURNEY_SUCCESS =
  'dofe-bo/advjouEvents/CREATE_ADVENTUROUS_JOURNEY_SUCCESS'
const CREATE_ADVENTUROUS_JOURNEY_FAIL =
  'dofe-bo/advjouEvents/CREATE_ADVENTUROUS_JOURNEY_FAIL'
const GET_AJ_EVENT_PARTICIPANT = 'dofe-bo/advjouEvents/GET_AJ_EVENT_PARTICIPANT'
const GET_AJ_EVENT_PARTICIPANT_SUCCESS =
  'dofe-bo/advjouEvents/GET_AJ_EVENT_PARTICIPANT_SUCCESS'
const GET_AJ_EVENT_PARTICIPANT_FAIL =
  'dofe-bo/advjouEvents/GET_AJ_EVENT_PARTICIPANT_FAIL'
const APPROVE_AJ_EVENT_PARTICIPANTS =
  'dofe-bo/advjouEvents/APPROVE_AJ_EVENT_PARTICIPANTS'
const APPROVE_AJ_EVENT_PARTICIPANTS_SUCCESS =
  'dofe-bo/advjouEvents/APPROVE_AJ_EVENT_PARTICIPANTS_SUCCESS'
const APPROVE_AJ_EVENT_PARTICIPANTS_FAIL =
  'dofe-bo/advjouEvents/APPROVE_AJ_EVENT_PARTICIPANTS_FAIL'
const SEARCH_AJ_EVENT_PARTICIPANTS =
  'dofe-bo/advjouEvents/SEARCH_AJ_EVENT_PARTICIPANTS'
const SEARCH_AJ_EVENT_PARTICIPANTS_SUCCESS =
  'dofe-bo/advjouEvents/SEARCH_AJ_EVENT_PARTICIPANTS_SUCCESS'
const SEARCH_AJ_EVENT_PARTICIPANTS_FAIL =
  'dofe-bo/advjouEvents/SEARCH_AJ_EVENT_PARTICIPANTS_FAIL'
const APPROVE_AJ_EVENT = 'dofe-bo/advjouEvents/APPROVE_AJ_EVENT'
const APPROVE_AJ_EVENT_SUCCESS = 'dofe-bo/advjouEvents/APPROVE_AJ_EVENT_SUCCESS'
const APPROVE_AJ_EVENT_FAIL = 'dofe-bo/advjouEvents/APPROVE_AJ_EVENT_FAIL'
const ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT =
  'dofe-bo/advjouEvents/ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT'
const ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT_SUCCESS =
  'dofe-bo/advjouEvents/ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT_SUCCESS'
const ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT_FAIL =
  'dofe-bo/advjouEvents/ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT_FAIL'
const SET_AJ_EVENT_PARTICIPANTS =
  'dofe-bo/advjouEvents/SET_AJ_EVENT_PARTICIPANTS'
const SET_AJ_EVENT_PARTICIPANTS_SUCCESS =
  'dofe-bo/advjouEvents/SET_AJ_EVENT_PARTICIPANTS_SUCCESS'
const SET_AJ_EVENT_PARTICIPANTS_FAIL =
  'dofe-bo/advjouEvents/SET_AJ_EVENT_PARTICIPANTS_FAIL'
const GET_AJPE_ASSESSMENT = 'dofe-bo/advjouEvents/GET_AJPE_ASSESSMENT'
const GET_AJPE_ASSESSMENT_SUCCESS =
  'dofe-bo/advjouEvents/GET_AJPE_ASSESSMENT_SUCCESS'
const GET_AJPE_ASSESSMENT_FAIL = 'dofe-bo/advjouEvents/GET_AJPE_ASSESSMENT_FAIL'
const CHANGE_AJP_STATE = 'dofe-bo/advjouEvents/CHANGE_AJP_STATE'
const CHANGE_AJP_STATE_SUCCESS = 'dofe-bo/advjouEvents/CHANGE_AJP_STATE_SUCCESS'
const CHANGE_AJP_STATE_FAIL = 'dofe-bo/advjouEvents/CHANGE_AJP_STATE_FAIL'
const CHANGE_AJP_GOAL = 'dofe-bo/advjouEvents/CHANGE_AJP_GOAL'
const CHANGE_AJP_GOAL_SUCCESS = 'dofe-bo/advjouEvents/CHANGE_AJP_GOAL_SUCCESS'
const CHANGE_AJP_GOAL_FAIL = 'dofe-bo/advjouEvents/CHANGE_AJP_GOAL_FAIL'

const AJPE_ASSESSMENT_RESEND = 'dofe-bo/advjouEvents/AJPE_ASSESSMENT_RESEND'
const AJPE_ASSESSMENT_RESEND_SUCCESS =
  'dofe-bo/advjouEvents/AJPE_ASSESSMENT_RESEND_SUCCESS'
const AJPE_ASSESSMENT_RESEND_FAIL =
  'dofe-bo/advjouEvents/AJPE_ASSESSMENT_RESEND_FAIL'

const SET_FILTER = 'dofe-bo/advjouEvents/SET_FILTER'
const SET_BASE_FILTER = 'dofe-bo/advjouEvents/SET_BASE_FILTER'
const SET_PARAMS = 'dofe-bo/advjouEvents/SET_PARAMS'
const SET_MY_EVENTS_PARAMS = 'dofe-bo/advjouEvents/SET_MY_EVENTS_PARAMS'
const SET_DISABLED_CACHE = 'dofe-bo/advjouEvents/SET_DISABLED_CACHE'
const REMOVE_DETAIL_DATA = 'dofe-bo/advjouEvents/REMOVE_DETAIL_DATA'
const REINIT = 'dofe-bo/advjouEvents/REINIT'
const REMOVE_AJ_PE_ASSESSMENT = 'dofe-bo/advjouEvents/REMOVE_AJ_PE_ASSESSMENT'

const initialState = {
  list: [],
  myEvents: {
    loading: false,
    loaded: false,
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null
  },
  detail: {},
  files: [],
  eventParticipants: [],
  searchResults: [],
  assessment: {
    data: {},
    loading: false
  },
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  count: null,
  filter: '',
  loading: false,
  loaded: false,
  sending: false,
  reportSent: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ADVENTUROUS_JOURNEYS:
      return {
        ...state,
        loading: true
      }
    case GET_ADVENTUROUS_JOURNEYS_SUCCESS:
      if (action.isMyList) {
        return {
          ...state,
          myEvents: {
            ...state.myEvents,
            loading: false,
            loaded: true,
            list: action.result,
            count: action.headers['x-total-count'],
            pages: Math.ceil(
              Number(action.headers['x-total-count']) / state.myEvents.limit
            ) || state.myEvents.pages
          }
        }
      }

      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: action.headers['x-total-count'],
        pages: Math.ceil(
          Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }
    case GET_ADVENTUROUS_JOURNEYS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ADVENTUROUS_JOURNEY:
      return {
        ...state,
        loading: true
      }
    case GET_ADVENTUROUS_JOURNEY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case GET_ADVENTUROUS_JOURNEY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ADVENTUROUS_JOURNEY_FILES:
      return {
        ...state,
        loading: true
      }
    case GET_ADVENTUROUS_JOURNEY_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        files: action.result
      }
    case GET_ADVENTUROUS_JOURNEY_FILES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case CRUD:
      return {
        ...state,
        loading: true
      }
    case CRUD_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case CRUD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case UPDATE_ADVENTUROUS_JOURNEY:
      return {
        ...state,
        loading: true
      }
    case UPDATE_ADVENTUROUS_JOURNEY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case UPDATE_ADVENTUROUS_JOURNEY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case AJPE_ASSESSMENT_RESEND:
      return {
        ...state,
        loading: true
      }
    case AJPE_ASSESSMENT_RESEND_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case AJPE_ASSESSMENT_RESEND_FAIL:
      return {
        ...state,
        loading: false
      }
    case CREATE_ADVENTUROUS_JOURNEY:
      return {
        ...state,
        loading: true
      }
    case CREATE_ADVENTUROUS_JOURNEY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case CREATE_ADVENTUROUS_JOURNEY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_AJ_EVENT_PARTICIPANT:
      return {
        ...state,
        loading: true
      }
    case GET_AJ_EVENT_PARTICIPANT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        eventParticipants: action.result,
        pages: Math.ceil(
          Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }
    case GET_AJ_EVENT_PARTICIPANT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case SEARCH_AJ_EVENT_PARTICIPANTS:
      return {
        ...state
      }
    case SEARCH_AJ_EVENT_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        searchResults: action.result
      }
    case SEARCH_AJ_EVENT_PARTICIPANTS_FAIL:
      return {
        ...state,
        error: action.error
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy,
        offset: 0
      })
    case SET_BASE_FILTER:
      return Object.assign({}, state, {
        baseFilter: action.filterBy
      })
    case SET_PARAMS:
      return {
        ...state,
        limit: action.options.limit !== undefined
          ? action.options.limit
          : state.limit,
        offset: action.options.offset !== undefined
          ? action.options.offset
          : state.offset,
        filter: action.options.filter !== undefined
          ? action.options.filter
          : state.filter,
        sort: action.options.sort !== undefined
          ? action.options.sort
          : state.sort
      }
    case SET_MY_EVENTS_PARAMS:
      return {
        ...state,
        myEvents: {
          ...state.myEvents,
          limit: action.options.limit !== undefined
            ? action.options.limit
            : state.myEvents.limit,
          offset: action.options.offset !== undefined
            ? action.options.offset
            : state.myEvents.offset,
          filter: action.options.filter !== undefined
            ? action.options.filter
            : state.myEvents.filter,
          sort: action.options.sort !== undefined
            ? action.options.sort
            : state.myEvents.sort
        }
      }
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    case REINIT:
      return initialState
    case ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT:
      return {
        ...state,
        sending: true
      }
    case ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT_SUCCESS:
      return {
        ...state,
        sending: false,
        reportSent: true,
        error: null
      }
    case ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT_FAIL:
      return {
        ...state,
        sending: false,
        reportSent: false,
        error: action.error
      }
    case GET_AJPE_ASSESSMENT:
      return {
        ...state,
        assessment: {
          ...state.assessment,
          loading: true
        }
      }
    case GET_AJPE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        assessment: {
          ...state.assessment,
          loading: false,
          data: action.result
        }
      }
    case GET_AJPE_ASSESSMENT_FAIL:
      return {
        ...state,
        assessment: {
          loading: false
        }
      }
    case REMOVE_AJ_PE_ASSESSMENT:
      return {
        ...state,
        assessment: {
          loading: false,
          data: {}
        }
      }
    default:
      return state
  }
}

export function getAjEvents(
  params,
  baseFilter,
  { listReadParams, isMyList = false, resetFilter = false } = {}
) {
  const modifiedParams = resetFilter
    ? {
      ...params,
      filter: ''
    }
    : params
  let defaultReadParams = 'CATEGORY,CREATED_BY'

  if (listReadParams) {
    defaultReadParams = `${defaultReadParams},${listReadParams}`
  }

  return {
    types: [
      GET_ADVENTUROUS_JOURNEYS,
      GET_ADVENTUROUS_JOURNEYS_SUCCESS,
      GET_ADVENTUROUS_JOURNEYS_FAIL
    ],
    promise: client =>
      client.get(
        `api/aj-events?with=${defaultReadParams}&${routeParams(modifiedParams, baseFilter)}`
      ),
    isMyList
  }
}

export function getAjEvent(id) {
  return {
    types: [
      GET_ADVENTUROUS_JOURNEY,
      GET_ADVENTUROUS_JOURNEY_SUCCESS,
      GET_ADVENTUROUS_JOURNEY_FAIL
    ],
    promise: client =>
      client.get(
        `api/aj-events/${id}?with=APPEND_CUSTOMIZATIONS,ASSESSOR_REGISTRATION_DATA,ASSESSOR_REGISTRATION,PARTICIPANT_EVENTS,AWARD_LEVEL,CATEGORY,CREATED_BY,PARTICIPANT_PERSON`
      )
  }
}

export function getAjEventFiles(id) {
  return {
    types: [
      GET_ADVENTUROUS_JOURNEY_FILES,
      GET_ADVENTUROUS_JOURNEY_FILES_SUCCESS,
      GET_ADVENTUROUS_JOURNEY_FILES_FAIL
    ],
    promise: client => client.get(`api/aj-events/${id}/award-files?with=AUTHOR`)
  }
}

export function uploadAjEventFile(id, data) {
  return {
    types: [UPLOAD_AJ_FILE, UPLOAD_AJ_FILE_SUCCESS, UPLOAD_AJ_FILE_FAIL],
    promise: client =>
      client.post(`api/aj-events/${id}/award-files`, {
        data
      })
  }
}

export function editAjEventFile(id, fileId, data) {
  return {
    types: [EDIT_AJ_FILE, EDIT_AJ_FILE_SUCCESS, EDIT_AJ_FILE_FAIL],
    promise: client =>
      client.put(`api/aj-events/${id}/award-files/${fileId}?update=OTHER`, {
        data
      })
  }
}

export function deleteAjEventFile(id, fileId) {
  return {
    types: [REMOVE_AJ_FILE, REMOVE_AJ_FILE_SUCCESS, REMOVE_AJ_FILE_FAIL],
    promise: client => client.del(`api/aj-events/${id}/award-files/${fileId}`)
  }
}

export function updateAjEvent(id, data) {
  return {
    types: [
      UPDATE_ADVENTUROUS_JOURNEY,
      UPDATE_ADVENTUROUS_JOURNEY_SUCCESS,
      UPDATE_ADVENTUROUS_JOURNEY_FAIL
    ],
    promise: client =>
      client.post(`api/aj-events/${id}/edit`, {
        data
      })
  }
}

export function deleteAjEvent(id) {
  return {
    types: [
      DELETE_ADVENTUROUS_JOURNEY,
      DELETE_ADVENTUROUS_JOURNEY_SUCCESS,
      DELETE_ADVENTUROUS_JOURNEY_FAIL
    ],
    promise: client => client.del(`api/aj-events/${id}`)
  }
}

export function createAjEvent(data) {
  return {
    types: [
      CREATE_ADVENTUROUS_JOURNEY,
      CREATE_ADVENTUROUS_JOURNEY_SUCCESS,
      CREATE_ADVENTUROUS_JOURNEY_FAIL
    ],
    promise: client =>
      client.post('api/aj-events/creation', {
        data
      })
  }
}

export function getAjParticipantEventAssessment(ajPeId, ajPeActionId) {
  return {
    types: [
      GET_AJPE_ASSESSMENT,
      GET_AJPE_ASSESSMENT_SUCCESS,
      GET_AJPE_ASSESSMENT_FAIL
    ],
    promise: client =>
      client.get(
        `api/aj-participant-events/${ajPeId}/assessments/${ajPeActionId}`
      )
  }
}

export function getPublicAjEventAssessmentRequests(
  ajPeId,
  ajPeActionId,
  authCode
) {
  return {
    types: [
      GET_AJPE_ASSESSMENT,
      GET_AJPE_ASSESSMENT_SUCCESS,
      GET_AJPE_ASSESSMENT_FAIL
    ],
    promise: client =>
      client.get(
        `api/aj-participant-events/${ajPeId}/assessment-requests/${ajPeActionId}/using-authorization-code?authorizationCode=${authCode}`,
        {
          removeToken: true,
          unauthorizedAction: false
        }
      )
  }
}

export function getPublicAjEvent(id, authCode) {
  return {
    types: [
      GET_AJ_EVENT_PARTICIPANT,
      GET_AJ_EVENT_PARTICIPANT_SUCCESS,
      GET_AJ_EVENT_PARTICIPANT_FAIL
    ],
    promise: client =>
      client.get(
        `api/aj-participant-events/${id}/using-authorization-code?authorizationCode=${authCode}&with=AWARD,PARTICIPANT_EVENTS,PARTICIPANT_DETAILS,ORGANIZATION`,
        {
          removeToken: true,
          unauthorizedAction: false
        }
      )
  }
}

export function approveAjEventParticipant(id, data) {
  return {
    types: [
      APPROVE_AJ_EVENT_PARTICIPANTS,
      APPROVE_AJ_EVENT_PARTICIPANTS_SUCCESS,
      APPROVE_AJ_EVENT_PARTICIPANTS_FAIL
    ],
    promise: client =>
      client.post(`api/aj-participant-events/${id}/award-leader-signoff`, {
        data
      })
  }
}

export function changeAjParticipantEventState(id, state, data = {}) {
  return {
    types: [CHANGE_AJP_STATE, CHANGE_AJP_STATE_SUCCESS, CHANGE_AJP_STATE_FAIL],
    promise: client =>
      client.post(
        `api/aj-participant-events/${id}/state-change?state=${state}`,
        {
          data
        }
      )
  }
}

export function changeAjParticipantEventGoal(id, data = {}) {
  return {
    types: [CHANGE_AJP_GOAL, CHANGE_AJP_GOAL_SUCCESS, CHANGE_AJP_GOAL_FAIL],
    promise: client =>
      client.post(`api/aj-participant-events/${id}/edit-aim`, {
        data
      })
  }
}

export function searchAjEventParticipant(
  input,
  awardLevelId = '',
  { disableNameFilter = false, rejectStates } = {}
) {
  const encodedInput = encodeURIComponent(input)
  const filter = !disableNameFilter
    ? `or(email ic ${encodedInput}, name ic ${encodedInput})`
    : ''

  let rejectFor = ''

  if (rejectStates) {
    let statesArr = [].concat(rejectStates)

    statesArr = statesArr.map(item => `awards.awardState.value ne ${item}`)
    rejectFor = encodeURIComponent(`and(${statesArr.join(',')})`)
  }

  return {
    types: [
      SEARCH_AJ_EVENT_PARTICIPANTS,
      SEARCH_AJ_EVENT_PARTICIPANTS_SUCCESS,
      SEARCH_AJ_EVENT_PARTICIPANTS_FAIL
    ],
    promise: client =>
      client.get(
        `api/participants?with=AWARDS,AWARD_LEVEL&filter=${rejectFor}${filter},personState.value=ACTIVE,awards.awardLevel.value=${awardLevelId}, awards.awardState.value in (REG_ASSIGNMENT,REG_APPROVAL,SETUP,IN_PROGRESS,LEADER_SIGNOFF)`
      )
  }
}

export function approveAjEvent(id, data) {
  return {
    types: [APPROVE_AJ_EVENT, APPROVE_AJ_EVENT_SUCCESS, APPROVE_AJ_EVENT_FAIL],
    promise: client =>
      client.post(`api/aj-events/${id}/approval`, {
        data
      })
  }
}

export function sendAjParticipantEventAssessorReport(id, authCode, data) {
  return {
    types: [
      ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT,
      ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT_SUCCESS,
      ASSESSOR_APPROVE_AJ_PARTIIPANT_EVENT_FAIL
    ],
    promise: client =>
      client.post(
        `api/aj-participant-events/${id}/assessor-reports/using-authorization-code?authorizationCode=${authCode}`,
        {
          data,
          removeToken: true,
          removeUserType: true
        }
      )
  }
}

export function setAjEventParticipants(id, data) {
  return {
    types: [
      SET_AJ_EVENT_PARTICIPANTS,
      SET_AJ_EVENT_PARTICIPANTS_SUCCESS,
      SET_AJ_EVENT_PARTICIPANTS_FAIL
    ],
    promise: client =>
      client.post(`api/aj-events/${id}/set-participants`, {
        data
      })
  }
}

export function exportAjEvents(params, baseFilter) {
  return {
    types: [EXPORT_AJ_EVENTS, EXPORT_AJ_EVENTS_SUCCESS, EXPORT_AJ_EVENTS_FAIL],
    promise: client =>
      client.get(
        `api/aj-events?with=PARTICIPANT_EVENTS,PARTICIPANT_PERSON,AWARD_LEVEL,CATEGORY,CREATED_BY,ORGANIZATION_NAME&${routeParams({ filter: params.filter }, baseFilter)}`
      )
  }
}

export function resendAjEventAssessmentRequest(id) {
  return {
    types: [
      AJPE_ASSESSMENT_RESEND,
      AJPE_ASSESSMENT_RESEND_SUCCESS,
      AJPE_ASSESSMENT_RESEND_FAIL
    ],
    promise: client =>
      client.post(`api/aj-participant-events/${id}/resend-assessment-requests`)
  }
}

export function setAjEventsFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setAjEventsBaseFilter(filterBy) {
  return {
    type: SET_BASE_FILTER,
    filterBy
  }
}

export function setAjEventsParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function setMyAjEventsParams(options) {
  return {
    type: SET_MY_EVENTS_PARAMS,
    options
  }
}

export function removeAjEventsDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function reinitAjEvents() {
  return {
    type: REINIT
  }
}

export function removeAjEventsCache() {
  return {
    type: SET_DISABLED_CACHE
  }
}

export function removeAjParticipantEventAssessment() {
  return {
    type: REMOVE_AJ_PE_ASSESSMENT
  }
}
/* eslint-enable */
